<template>
  <div class="home-page">
    <!-- 学习记录区域 -->
    <section class="section" v-if="history.length > 0">
      <div class="section-header">
        <h3>课件播放记录</h3>
        <div class="more-link" @click="more()">查看更多</div>
      </div>
      <div class="record-list">
        <div
            class="record-card"
            v-for="(item, index) in history"
            @click="course(item.news_id)"
            :key="index"
        >
          <div
              class="card-tag"
              :class="[
              item.type === 1
                ? 'tag-high'
                : item.type === 2
                ? 'tag-middle'
                : 'tag-low',
            ]"
          >
            {{
            item.type === 1
            ? "高级课程"
            : item.type === 2
            ? "中级课程"
            : "初级课程"
            }}
          </div>
          <div class="card-content">
            <div class="card-info">
              <div class="name">{{ item.name }}</div>
              <p class="card-time">{{ item.study_at }}学习</p>
              <p class="card-desc">{{ item.remark }}</p>
            </div>
            <div class="card-cover">
              <img :src="item.cover" alt=""/>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 直播课区域 -->
    <section class="section" v-if="lives.length > 0">
      <div class="section-header">
        <h3>直播课</h3>
        <div class="more-link" @click="moreLive()">更多直播</div>
      </div>
      <div class="live-list">
        <div
            class="live-card"
            v-for="(item, index) in lives"
            :key="index"
            @click="handleLiveClick(item.id)"
        >
          <div class="live-logo">
            <img :src="item.cover" alt="logo"/>
          </div>
          <div class="live-info">
            <h4>{{ item.name }}</h4>
            <div
                class="live-status"
                :class="{
                'status-live': item.status === 1,
                'status-wait': item.status === 0,
                'status-end': item.status === 2,
              }"
            >
              <span class="status-dot"></span>
              <span>{{
                item.status === 0
                  ? "未开播"
                  : item.status === 1
                  ? "直播中"
                  : item.status === 2
                  ? "已结束"
                  : ""
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 直播中/未开播：iframe -->
    <div v-if="showPlayer && liveStatus !== 2" class="live-iframe-container">
      <div class="iframe-header">
        <h3>{{ currentLiveTitle }}</h3>
        <button class="close-btn" @click="closePlayer">× 关闭</button>
      </div>
      <iframe
          :src="currentLiveUrl"
          frameborder="0"
          class="live-iframe"
          allowfullscreen
          @load="injectIframeProtection"
      ></iframe>
    </div>

    <!-- 已结束：video 播放器 -->
    <div v-if="showPlayer && liveStatus === 2" class="video-container">
      <div class="video-header">
        <h3>{{ currentLiveTitle }}</h3>
        <button class="close-btn" @click="closePlayer">× 关闭</button>
      </div>
      <video
          class="live-video"
          controls
          controlslist="nodownload noplaybackrate"
          disablePictureInPicture
          autoplay
          :src="currentVideoUrl"
      ></video>
    </div>

    <!-- 推荐课程区域 -->
    <section class="section">
      <div class="section-header">
        <h3>课程</h3>
        <!-- <div class="more-link" @click="moreReferral()">更多课程</div> -->
      </div>
      <div class="pickFileList">
        <div
            class="item"
            v-for="(item, index) in pickFileList"
            @click="pickHistory(item, index)"
            :key="index"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="course-list">
        <!-- 文件夹 -->
        <div
            class="file_item"
            v-for="(item, index) in sublist"
            @dblclick="openfile(item)"
            :key="'key' + index"
        >
          <div class="img">
            <img src="@/assets/file.png" alt=""/>
          </div>
          {{ item.name }}
        </div>
        <div class="course-card" v-for="(item, index) in list" :key="index">
          <div class="course-cover">
            <img :src="item.cover" alt=""/>
          </div>
          {{ item.name }}
          <div class="course-info">
            <div class="mask"></div>
            <!-- <span class="meta-study">{{ item.see_num }}人已学</span> -->
            <button class="join-btn" @click.stop="openDialog(item.id)">
              加入学习路线
            </button>
            <button
                class="join-btn"
                style="background: #8c33ff"
                @click.stop="course(item.id)"
            >
              阅读
            </button>
            <button
                class="join-btn"
                style="background: rgb(1 187 60)"
                v-if="item.can_upload == 1"
                @click.stop="download(item.id)"
            >
              下载
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- 无数据 -->
    <div class="empty-state" v-if="list.length === 0 && sublist.length == 0">
      <img class="empty-image" src="@/assets/empty-data.png" alt="暂无数据"/>
      <p class="empty-text">暂无课程数据</p>
    </div>

    <join-dialog ref="Dialog"></join-dialog>
  </div>
</template>

<script>
  import {
    newsHistory,
    livesList,
    livesInfo,
    newsList,
    newsCate,
    newsInfo,
    userInfo,
  } from "@/api/api";
  import joinDialog from "@/components/joinDialog.vue";

  export default {
    name: "Home",
    components: {
      joinDialog,
    },
    data() {
      return {
        history: [],
        lives: [],
        list: [],
        showPlayer: false,
        liveStatus: 0,
        currentLiveUrl: "",
        currentVideoUrl: "",
        currentLiveTitle: "",
        info: {},
        name: "",
        cate: [],
        cateids: "",
        fileList: {},
        sublist: [],
        alldata: [],
        pickFileList: [],
        page: 1,
        limit: 999
      };
    },
    mounted() {
      this.newsHistory();
      this.livesList();
      this.newsList();
      this.userInfo();
    },
    methods: {
      pickHistory(e, index) {
        let list = [];
        for (let i in this.pickFileList) {
          if (i <= index) {
            list.push(this.pickFileList[i]);
          }
        }
        this.pickFileList = list;
        this.cateids = e.id;
        if (e.sub && e.sub.length > 0) {
          this.sublist = e.sub;
        } else {
          this.sublist = [];
        }
        this.newsList();
      },
      openfile(e) {
        console.log(e);
        if (this.pickFileList.length == 0) {
          this.pickFileList.push(this.fileList.item);
        }
        this.pickFileList.push(e);
        this.cateids = e.id;
        if (e.sub && e.sub.length > 0) {
          this.sublist = e.sub;
        } else {
          this.sublist = [];
        }
        this.newsList();
      },
      injectIframeProtection() {
        console.log("window.disableDevtool", window);
      },
      openDialog(news_id) {
        this.$refs.Dialog.show(news_id);
      },
      // 接收搜索
      handleSearch(data) {
        this.name = data;
        this.livesList();
        this.newsList();
      },
      // 接收菜单筛选
      handleMenuSearch(data) {
        this.cateids = data.cateids;
        this.fileList = data;
        if (data.item && data.item.sub && data.item.sub.length > 0) {
          this.sublist = data.item.sub;
        } else {
          this.sublist = [];
          this.pickFileList = [];
        }
        console.log("alldata", data);
        this.newsList();
      },
      userInfo() {
        userInfo().then((res) => {
          this.info = res.data;
        });
      },
      newsHistory() {
        let params = {
          page: this.page,
          limit: this.limit,
        };
        newsHistory(params).then((res) => {
          this.history = res.data.list;
        });
      },
      livesList() {
        let params = {
          page: this.page,
          limit: this.limit,
          name: this.name,
        };
        livesList(params).then((res) => {
          this.lives = res.data.list;
        });
      },
      handleLiveClick(id) {
        livesInfo(id).then((res) => {
          this.liveStatus = res.data.status;
          if (res.data.status === 2) {
            this.currentVideoUrl = res.data.video_url;
          } else {
            if (res.data.url.startsWith("https://")) {
              this.currentLiveUrl = `https://ow365.cn/?i=37451&ssl=0&furl=${res.data.url}`;
            } else if (res.data.url.startsWith("http://")) {
              this.currentLiveUrl = `https://ow365.cn/?i=37451&ssl=0&furl=${res.data.url}`;
            }
          }
          this.currentLiveTitle = res.data.name;
          this.showPlayer = true;
          this.$nextTick(() => {
            let dom =
                this.liveStatus === 2
                    ? document.querySelector(".video-container")
                    : document.querySelector(".live-iframe-container");
            if (dom) dom.scrollIntoView({behavior: "smooth"});
          });
        });
      },
      course(id) {
        newsInfo(id).then((res) => {
          if (res.data.url.startsWith("https://")) {
            this.currentLiveUrl = `https://ow365.cn/?i=37451&ssl=0&furl=${res.data.url}`;
          } else if (res.data.url.startsWith("http://")) {
            this.currentLiveUrl = `https://ow365.cn/?i=37451&ssl=0&furl=${res.data.url}`;
          }
          this.currentLiveTitle = res.data.name;
          this.showPlayer = true;
          this.liveStatus = 1;
          this.$nextTick(() => {
            const dom = document.querySelector(".live-iframe-container");
            if (dom) dom.scrollIntoView({behavior: "smooth"});
          });
        });
      },
      download(id) {
        newsInfo(id).then((res) => {
          const encodedUrl = res.data.url;
          // 解码：将 %20 还原为空格，显示为 "1Maisy -Farm-teest.pptx"
          const displayName = decodeURIComponent(encodedUrl);
          console.log("display", displayName);
          window.open(displayName, "_blank");
        });
      },
      closePlayer() {
        this.showPlayer = false;
        this.currentLiveUrl = "";
        this.currentVideoUrl = "";
        this.currentLiveTitle = "";
        this.liveStatus = 0;
      },
      newsList() {
        this.list = [];
        let params = {
          page: this.page,
          limit: this.limit,
          name: this.name,
          cateids: this.cateids,
        };
        if(this.sublist.length === 0) {
          newsList(params).then((res) => {
            this.list = res.data.list;
          });
        }
      },
      more() {
        this.$router.push({path: "/record"});
      },
      moreLive() {
        this.$router.push({path: "/live"});
      },
      moreReferral() {
        this.$router.push({path: "/referral"});
      },
    },
  };
</script>

<style lang="less" scoped>
  .home-page {
    padding: 0;
  }

  .section {
    margin-bottom: 40px;

    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;

      h3 {
        font-size: 18px;
        font-weight: 600;
        color: #1e293b;
        margin: 0;
      }

      .more-link {
        font-size: 14px;
        color: #3a44f7;
        cursor: pointer;
      }
    }
  }

  .record-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;

    .record-card {
      background: #fff;
      border-radius: 12px;
      padding: 15px;
      cursor: pointer;
      border: 1px solid #f1f1f1;

      .card-tag {
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 500;
        display: inline-block;
        float: left;

        &.tag-high {
          background: #fef2f2;
          color: #ef4444;
        }

        &.tag-middle {
          background: #fffbeb;
          color: #f59e0b;
        }

        &.tag-low {
          background: #eff6ff;
          color: #3a44f7;
        }
      }

      .card-content {
        display: flex;
        width: 100%;
        position: relative;

        .card-info {
          flex: 1;

          .name {
            font-size: 14px;
            color: #1e293b;
            margin: 15px 0;
            text-align: left;
          }

          .card-time {
            font-size: 12px;
            color: #94a3b8;
            margin-bottom: 15px;
            text-align: left;
          }

          .card-desc {
            font-size: 12px;
            color: #64748b;
            text-align: left;
          }
        }

        .card-cover {
          width: 80px;
          height: 80px;
          border-radius: 12px;
          position: absolute;
          top: -20px;
          right: 0;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }

  .live-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  .live-card {
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    border: 1px solid #f1f1f1;
  }

  .live-logo {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .live-info {
    flex: 1;
  }

  .live-info h4 {
    margin: 0 0 6px 0;
    font-size: 14px;
    color: #1e293b;
    text-align: left;
  }

  .live-status {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
  }

  .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  .status-live {
    color: #22c55e;

    .status-dot {
      background: #22c55e;
    }
  }

  .status-wait {
    color: #ef4444;

    .status-dot {
      background: #ef4444;
    }
  }

  .status-end {
    color: #94a3b8;

    .status-dot {
      background: #94a3b8;
    }
  }

  .course-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    .course-card {
      width: 160px;
      background: #fff;
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #f1f1f1;
      position: relative;
      height: 160px;

      .course-cover {
        width: 100%;
        height: 100px;
        overflow: hidden;
        line-height: 1;
        margin-bottom: 20px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
      }

      .course-info {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 20px;
        display: none;
        flex-direction: column;

        .join-btn {
          display: flex;
          align-items: center;
          padding: 8px 10px;
          position: relative;
          justify-content: center;
          font-size: 14px;
          color: #fff;
          background: #3355ff;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          margin-bottom: 10px;

          &:hover {
            opacity: 0.9;
          }
        }
      }

      &:hover .course-info {
        display: flex;
      }
    }
  }

  .live-iframe-container,
  .video-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    display: flex;
    flex-direction: column;
  }

  .live-iframe-container {
    background: #fff;
  }

  .video-container {
    background: #000;
  }

  .iframe-header,
  .video-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #2f54eb;
    color: #fff;
    height: 56px;
    flex-shrink: 0;
  }

  .live-iframe,
  .live-video {
    flex: 1;
    border: none;
  }

  .live-video {
    height: 50%;
  }

  .close-btn {
    padding: 6px 12px;
    background: #fff;
    color: #2f54eb;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 80px 20px;

    .empty-image {
      width: 200px;
      /*height: 200px;*/
      opacity: 0.7;
    }

    .empty-text {
      font-size: 16px;
      color: #94a3b8;
    }
  }

  .file_item {
    width: 160px;
    height: 160px;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 16px;
    border: 1px solid #f1f1f1;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      background: #f4f7ff;
    }

    .img {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 160px;
      height: 120px;

      img {
        width: 80px;
        height: 80px;
      }
    }
  }

  .pickFileList {
    display: flex;
    align-content: center;
    margin-bottom: 20px;

    .item {
      font-size: 18px;
      cursor: pointer;
      font-weight: bold;

      &::after {
        content: ">";
        color: #333 !important;
        display: inline-block;
        transform: scaleX(0.6);
        margin: 0 10px;
      }

      &:hover {
        color: #3a86f7;
      }
    }
  }
</style>
